import uniqby from "lodash/uniqBy";
import upperFirst from "lodash/upperFirst";
import capitalize from "lodash/capitalize";
import lodgingTypes from "../constants/lodgingTypes";
import placeTypes from "../../../../server/lib/open-planet/placeTypes";
import resourceTypes from "../../../../server/lib/open-planet/resourceTypes";

const _ = { uniqby, upperFirst, capitalize };

export const uniquePois = (items) => items;

export const mapCenter = (pois) => {
  if (pois.length > 0 && pois[0].containingPlace) {
    const place = pois[0].containingPlace;
    return place && place.center ? place.center.coordinates : null;
  }

  if (pois.length > 0 && pois[0].lodging && pois[0].lodging.containingPlace) {
    const place = pois[0].lodging.containingPlace;
    return place && place.center ? place.center.coordinates : null;
  }

  return null;
};

export const getSubtypes = (subtypes, resource) => {
  if (!subtypes) return [];

  if (resource === resourceTypes.lodging) {
    return lodgingTypes.map((s) => ({ name: _.upperFirst(s), checked: false }));
  }

  return subtypes.map((s) => ({ name: s.value[0], checked: false }));
};

export const getFacilities = () =>
  ([
    "free wifi",
    "free parking",
    "free breakfast",
    "pool",
    "restaurant",
    "air conditioning",
    "fitness centre",
    "shuttle",
    "pets allowed",
    "bar",
    "kid-friendly",
  ].map(amenity =>
    ({
      checked: false,
      name: _.capitalize(amenity),
    })
  ));


export const getNeighborhoods = (place) => {
  if (place.placeType === "city" && Array.isArray(place.descendants)) {
    return place.descendants
    .filter(p => p.placeType === placeTypes.neighborhood).map(p => ({
      name: p.name,
      checked: false,
      value: p.id,
    }));
  }
  return [];
};



// WEBPACK FOOTER //
// ./assets/list/selectors/index.js